<template>
    <div class="custom-actions">
        <button class="" @click="showDetails(rowData, rowIndex)">
            Details
        </button>
    </div>
</template>

<script>

export default {
    props: {
        rowData: {
            type: Object,
            required: true
        },
        rowIndex: {
            type: Number
        },
        test: {
            type: String,
            required: false
        }
    },
    methods: {
        showDetails (data, index) {
            window.open('www.google.com', '_blank');
        }
    }
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/custom-actions/CustomActions.vue